import { Injectable } from '@angular/core';

import { AccountSetupContext } from '@sondermind/constants';

@Injectable({
  providedIn: 'root',
})
export class AccountSetupService {
  private setupContext: AccountSetupContext | null = null;

  get context(): AccountSetupContext | null {
    return this.setupContext;
  }

  set context(newContext: AccountSetupContext) {
    this.setupContext = newContext;
  }

  clearContext() {
    this.setupContext = null;
  }
}
